.fp-vertical-spacing.-s-sm
  .fp-vertical-spacing--line(v-for='(question, index) in giveawayParticipation.answeredQuestions' :key='index' :data-test='`question-${index}`')
    .fp-horizontal-spacing.-s-sm
      .fp-horizontal-spacing--column.-expand(data-test='title') {{ question.questionTitle }}
      .fp-horizontal-spacing--column(data-test='answer-text')
        span.fp-text(v-if='question.answerText') {{ question.answerText }}
        span.fp-text.-color-shade-400(v-else data-test='no-answer') {{ t('giveawayResults.participations.noAnswer')}}
      .fp-horizontal-spacing--column(v-if='question.iconClass' data-test='icon')
        i.fp-icon.-s12(:class='question.iconClass')
